export class SenderOptionBase {}
